import * as actionTypes from "../actionTypes";

const initialState = {
    flightImageData: [],
};

const flightImageReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_FLIGHT_IMAGES: {
            return {
                ...state,
                flightImageData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default flightImageReducer;
